import { IPrismicLinkTarget } from '@/pageGeneration/services/prismicApi/types';

const linkTargetPath = (linkTarget: IPrismicLinkTarget) => `/${linkTarget.uid}`;

export default linkTargetPath;
